import { Component,  Input, Output, EventEmitter } from '@angular/core';
import { CfetBaseComponent } from '../../../cfet-core';

@Component({
    selector: 'app-file-confirmation-delete-modal-utf',
    templateUrl: './file-confirmation-delete-modal-utf.component.html',
    styleUrls: ['./file-confirmation-delete-modal-utf.component.scss'],
    standalone: false
})
export class FileConfirmationDeleteModalUtfComponent extends CfetBaseComponent {

  constructor() { super(); }

  @Input() openModal: string;
  @Input() selectedFile: string;
  @Output() modalCloseEvent = new EventEmitter<any>();

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method

  cancel(event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this[modalAction] = 'close';
      this.modalCloseEvent.emit('modalClose');
    }
  }

  delete(event, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.modalCloseEvent.emit('DeleteFile');
      this.modalCloseEvent.emit('modalClose');
      this[modalAction] = 'close';
    }
  }

  close(event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click'
      || event.keyCode === 13 || event.type === 'clicked outside') {
      this[modalAction] = 'close';
      this.modalCloseEvent.emit('modalClose');
    }
  }
}
